import { useCallback } from "react";
import { useEvent } from "hooks";

// hook to handle message events
export function usePostMessageHandler(
    handlers: {
        [key: string]: (
            data: any,
            source: MessageEventSource | Window | null
        ) => void;
    },
    parentWindow: Window = window.parent
) {
    // calls the registered handler for a given message type
    const handleMessage = useCallback(
        (data: any, source: MessageEventSource | Window | null) => {
            if (data == null || data.source !== "inPoint") return;
            const handler = handlers[data.type];
            if (handler == null || typeof handler !== "function") return;
            handler(data.data, source);
        },
        [handlers]
    );

    const onMessage = useCallback(
        (e: MessageEvent) => {
            // some security checks
            if (!e.isTrusted || e.data == null) return;

            /* istanbul ignore next */
            try {
                if (
                    window !== parentWindow &&
                    window.location.href !== parentWindow.location.href &&
                    window.location.origin === parentWindow.location.origin
                ) {
                    // forward message
                    parentWindow.postMessage(e.data, "*");
                }
            } catch (e: any) {
                console.error(e.message);
            }
            // handle
            if (Array.isArray(e.data)) {
                e.data.forEach((d: any) => handleMessage(d, e.source));
            } else handleMessage(e.data, e.source);
        },
        [handleMessage, parentWindow]
    );

    useEvent("message", onMessage);
}
